export class AdicionaContratoDocumentoDto {

  contratoId: number = 0;

  itemDestinoId: number = 0;

  tipoDocumentoDestino: number = 0;
}
